module.exports = __webpack_public_path__ + "static/media/geospatial-analysis.4ecf7023.svg";